<app-modal [header]="options?.header" [hasFooter]="false" [closable]="closable" (closed)="close()">
  <div body>
    <video class="w-100 h-auto" controls autoplay>
      <source [src]="options?.data?.toString() || ''" type="video/mp4" />
      {{ 'shared.video.browser-not-supported-video' | translate }}
    </video>
  </div>
</app-modal>
